import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function appReducer(state = initialState.app, action) {
    return state;
}
